export enum Paths {
  home = "/",
  sketchId = "/:sketchId",
}
